import React from 'react';
import { admins } from 'types';
import MaterialTable from 'components/table';
import adminPermissionRoleColumns from './admin-permission-role.columns';

interface IAdminPermissionRoleProps {
    data: admins.TAdminPermissionRole[];
    isLoading: boolean;
}

const AdminPermissionRole: React.FC<IAdminPermissionRoleProps> = ({
    data,
    isLoading,
}) => {
    return (
        <>
            <MaterialTable<admins.TAdminPermissionRole>
                data={data}
                columns={adminPermissionRoleColumns()}
                isLoading={isLoading}
            />
        </>
    );
};

export default AdminPermissionRole;
